import React from 'react';
import Utils from 'utilities/helper.util';
import { isIOS } from 'react-device-detect';

export const JobDateSection: React.FC<any> = (props: any) => {
  const { digStartAt, digEndAt } = props;

  return (
    <p>
      Job dates {Utils.toLocalDateFormat(digStartAt)}{' '}
      {isIOS ? <span className="arrow-symbol">&#8594;</span> : '⟶'}{' '}
      {Utils.toLocalDateFormat(digEndAt)}
    </p>
  );
};
JobDateSection.displayName = 'JobDate';
export default React.memo(JobDateSection);
